import { render, staticRenderFns } from "./Produtos.vue?vue&type=template&id=c6ca1104&scoped=true&"
import script from "./Produtos.vue?vue&type=script&lang=js&"
export * from "./Produtos.vue?vue&type=script&lang=js&"
import style0 from "./Produtos.vue?vue&type=style&index=0&id=c6ca1104&scoped=true&lang=css&"
import style1 from "./Produtos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca1104",
  null
  
)

export default component.exports